import { useAuthContext } from "@/context/AuthContext";
import { useCartContext } from "@/context/CartContext";
import Button from "@/components/button";
import { formatCurrency } from "@/utils/formatCurrency";

interface AddMaxValueButtonProps {
  maxValue: number;
  onAdd: (amount: number) => Promise<void>;
  disabled?: boolean;
}

export const AddMaxValueButton = ({
  maxValue,
  onAdd,
  disabled,
}: AddMaxValueButtonProps) => {
  const { user } = useAuthContext();
  const { totalCostPoints } = useCartContext();

  // Calculate available dollars for quick max add
  const availablePoints = Math.max(0, (user.points || 0) - totalCostPoints);
  const availableDollars = Math.floor(availablePoints / 5);

  const effectiveMax = Math.min(maxValue, availableDollars);

  if (effectiveMax <= 0) {
    return null;
  }

  return (
    <Button
      onClick={() => onAdd(effectiveMax)}
      variant="outlined"
      data-cypress="add-max-affordable-button"
      disabled={disabled}
      sx={{
        color: "#1976d2",
        borderColor: "#1976d2",
        "&:hover": {
          borderColor: "#1565c0",
          backgroundColor: "rgba(25, 118, 210, 0.04)",
        },
      }}
    >
      Add max value {formatCurrency(effectiveMax)} ({effectiveMax * 5} Points)
      to cart
    </Button>
  );
};
